import { Avatar, Button, Pagination, Table, TableBody, TableCell, TableHead, TableRow, IconButton } from "@mui/material";
import { CiWavePulse1 } from "react-icons/ci";
import { CiCirclePlus } from "react-icons/ci";
import BlogEditor from "./BlogEditor";
import { useEffect, useState } from "react";
import { ApiRequest } from "GlobalFunctions";
import Box from "elements/Box";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useSnackbar } from 'notistack';
import AlertDialog from "elements/AlertDialog";

export default function BlogList(props: any) {

    const [openEditor, setOpenEditor] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [activeItem, setActiveItem] = useState<any>(null);
    const [openAlert, setOpenAlert] = useState(false);

    const { enqueueSnackbar } = useSnackbar();

    const [list, setList] = useState([]);
    const loadList = async () => {
        ApiRequest({
            url: '/blog/globalList',
            method: 'GET',
            query: {
                page: page
            },
            setResponse: (response: any) => {
                setList(response.list);
                setTotalPages(response.total_pages);
            }
        });
    }

    useEffect(() => {
        loadList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    const handleDelete = (blog_id: number) => {
        setActiveItem(blog_id);
        setOpenAlert(true);
    };

    const deleteItem = () => {
        ApiRequest({
            url: '/blog/deleteItem',
            method: 'POST',
            body: { blog_id: activeItem },
            setResponse: (response: any) => {
                setOpenAlert(false);
                if (response.status === 'success') {
                    enqueueSnackbar('Entrada de blog eliminada con éxito', { variant: 'success' });
                    loadList();
                } else {
                    enqueueSnackbar(response.message || 'Error al eliminar', { variant: 'error' });
                }
            },
            onError: (msg: string) => {
                setOpenAlert(false);
                enqueueSnackbar(msg, { variant: 'error' });
            },
        });
    };

    return (
        <>
        <div className="content">
            <div className='blog_title_row'>
                <h2 className='titles'><CiWavePulse1 size={25} />Blog</h2>

                <Button
                    variant='contained'
                    startIcon={<CiCirclePlus />}
                    onClick={() => {
                        setActiveItem(null);
                        setOpenEditor(true);
                    }}
                    >
                        Nueva entrada
                 </Button>
                
            </div>
            <Box className='blog_entries'>
                    <Table aria-label="sticky table"> 
                        <TableHead>
                            <TableRow>
                                <TableCell>Título</TableCell>
                                <TableCell>Fecha</TableCell>
                                <TableCell>Autor</TableCell>
                                <TableCell>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.length > 0 && list.map((blog: any, index: number) => (
                                <TableRow key={index}>
                                    <TableCell>{blog.title}</TableCell>
                                    <TableCell>{blog.created_at}</TableCell>
                                    <TableCell>
                                        <div className="blog_author_link">
                                            <Avatar src={blog.user_image} />
                                            <span>{blog.author}</span>
                                        </div>
                                    </TableCell>
                                    <TableCell align="right">
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Button 
                                                size="small"
                                                variant="contained"
                                                color="primary"
                                                style={{"marginRight": "10px"}}
                                                startIcon={<ModeEditIcon />}
                                                onClick={() => {
                                                    setActiveItem(blog.blog_id);
                                                    setOpenEditor(true);
                                                }}
                                            >
                                                Editar
                                            </Button>
                                            <IconButton 
                                                aria-label="delete" 
                                                color="error" 
                                                onClick={() => handleDelete(blog.blog_id)}
                                            >
                                                <DeleteOutlineOutlinedIcon /> 
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
            </Box>
            {totalPages > 1 && (
                <div className="pagination_container">
                    <Pagination 
                        count={totalPages} 
                        page={page}  
                        onChange={(event, value) => setPage(value)} 
                        color="primary"
                        style={{"marginTop": "20px","alignSelf": "center"}}
                    />
                </div>
            )}
        </div>

        <BlogEditor open={openEditor} setOpen={setOpenEditor} loadList={loadList} activeItem={activeItem} blog_id={activeItem} />
        <AlertDialog
            open={openAlert}
            setOpen={setOpenAlert}
            subtitle="¿Está seguro que desea eliminar esta entrada de blog?"
            send={deleteItem}
        />
        </>
    );
}
